var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 105,
    viewBox: "0 0 103 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "presentation 1",
    clipPath: "url(#clip0_605_4053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.5098 75.6267H59.4899V97.1886H43.5098V75.6267Z",
    fill: "url(#paint0_linear_605_4053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M70.0319 103.838H32.9681C30.2973 103.838 28.1323 101.631 28.1323 98.9079C28.1323 96.1853 30.2973 93.9783 32.9681 93.9783H70.0319C72.7026 93.9783 74.8677 96.1853 74.8677 98.9079C74.8677 101.63 72.7026 103.838 70.0319 103.838Z",
    fill: "url(#paint1_linear_605_4053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M43.5098 82.6004L57.8199 97.1884H59.4901V75.6267H43.5098V82.6004Z",
    fill: "url(#paint2_linear_605_4053)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M95.3045 82.6004H7.69551C3.44545 82.6004 0 79.0883 0 74.7557V16.7907C0 12.4582 3.44545 8.9458 7.69551 8.9458H95.3047C99.5548 8.9458 103 12.4582 103 16.7907V74.7557C103 79.0883 99.5546 82.6004 95.3045 82.6004Z",
    fill: "url(#paint3_linear_605_4053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M70.5366 8.9458L82.1964 20.832V75.6266H70.5366V8.9458Z",
    fill: "url(#paint4_linear_605_4053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M89.4969 75.6266H13.5031C9.94876 75.6266 7.06738 72.6893 7.06738 69.0659V22.4803C7.06738 18.857 9.94876 15.9197 13.5031 15.9197H89.4969C93.0512 15.9197 95.9326 18.857 95.9326 22.4803V69.0659C95.9326 72.6895 93.0512 75.6266 89.4969 75.6266Z",
    fill: "url(#paint5_linear_605_4053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M77.3776 15.9197H70.5366V75.6266H82.1964V20.832L77.3776 15.9197Z",
    fill: "url(#paint6_linear_605_4053)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M0 68.1455V74.7554C0 79.0879 3.44545 82.6003 7.69551 82.6003H95.3047C99.5548 82.6003 103 79.0879 103 74.7554V68.1455H0Z",
    fill: "url(#paint7_linear_605_4053)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M51.0884 28.3289L57.5004 34.8654V75.6264H51.0884V28.3289Z",
    fill: "url(#paint8_linear_605_4053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M88.249 43.114L94.6611 49.6506V70.6977C94.6611 73.4199 92.4965 75.6265 89.8261 75.6265H88.249V43.114Z",
    fill: "url(#paint9_linear_605_4053)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M51.9089 75.6265H37.8638V30.0512C37.8638 28.5301 39.0733 27.2969 40.5656 27.2969H49.2073C50.6994 27.2969 51.9091 28.5299 51.9091 30.0512V75.6265H51.9089Z",
    fill: "url(#paint10_linear_605_4053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M70.5369 75.6265H56.4917V3.91665C56.4917 2.39559 57.7012 1.16235 59.1935 1.16235H67.8352C69.3273 1.16235 70.5371 2.39538 70.5371 3.91665V75.6265H70.5369Z",
    fill: "url(#paint11_linear_605_4053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M89.1648 75.6266H75.1196V45.1603C75.1196 43.6392 76.3292 42.406 77.8215 42.406H86.4632C87.9552 42.406 89.165 43.639 89.165 45.1603V75.6266H89.1648Z",
    fill: "url(#paint12_linear_605_4053)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M18.3534 33.1705H11.822C11.2272 33.1705 10.7451 32.679 10.7451 32.0727V29.0763C10.7451 28.47 11.2272 27.9785 11.822 27.9785H18.3534C18.9482 27.9785 19.4302 28.47 19.4302 29.0763V32.0727C19.4302 32.679 18.9482 33.1705 18.3534 33.1705Z",
    fill: "#7ACBFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M34.2093 33.1705H22.5588C21.964 33.1705 21.4819 32.679 21.4819 32.0727V29.0763C21.4819 28.47 21.964 27.9785 22.5588 27.9785H34.2093C34.8041 27.9785 35.2862 28.47 35.2862 29.0763V32.0727C35.2862 32.679 34.8041 33.1705 34.2093 33.1705Z",
    fill: "#7ACBFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M27.6779 40.9905H34.2093C34.8041 40.9905 35.2862 40.4991 35.2862 39.8928V36.8963C35.2862 36.29 34.8041 35.7986 34.2093 35.7986H27.6779C27.0832 35.7986 26.6011 36.29 26.6011 36.8963V39.8928C26.6011 40.4991 27.0834 40.9905 27.6779 40.9905Z",
    fill: "#7ACBFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M11.822 40.9905H23.4725C24.0673 40.9905 24.5493 40.4991 24.5493 39.8928V36.8963C24.5493 36.29 24.0673 35.7986 23.4725 35.7986H11.822C11.2272 35.7986 10.7451 36.29 10.7451 36.8963V39.8928C10.7451 40.4991 11.2274 40.9905 11.822 40.9905Z",
    fill: "#7ACBFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M18.3534 48.8106H11.822C11.2272 48.8106 10.7451 48.3192 10.7451 47.7128V44.7164C10.7451 44.1101 11.2272 43.6187 11.822 43.6187H18.3534C18.9482 43.6187 19.4302 44.1101 19.4302 44.7164V47.7128C19.4302 48.3192 18.9482 48.8106 18.3534 48.8106Z",
    fill: "#7ACBFF"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_605_4053",
    x1: 43.5098,
    y1: 86.4075,
    x2: 59.4901,
    y2: 86.4075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F73A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174461"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_605_4053",
    x1: 51.5,
    y1: 94.8821,
    x2: 51.5,
    y2: 101.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F73A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174461"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_605_4053",
    x1: 55.8843,
    y1: 91.5507,
    x2: 51.0786,
    y2: 78.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#092A40",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#092A40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_605_4053",
    x1: 25.814,
    y1: 19.5885,
    x2: 81.1927,
    y2: 73.9121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F73A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174461"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_605_4053",
    x1: 66.4675,
    y1: 39.4874,
    x2: 57.986,
    y2: 33.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#092A40",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#092A40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_605_4053",
    x1: 29.8841,
    y1: 23.7376,
    x2: 76.4877,
    y2: 69.4535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_605_4053",
    x1: 80.5824,
    y1: 45.7732,
    x2: 67.7574,
    y2: 45.7732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ACBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F73A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_605_4053",
    x1: 51.5,
    y1: 73.3195,
    x2: 51.5,
    y2: 82.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#092A40",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#092A40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_605_4053",
    x1: 56.0104,
    y1: 51.9777,
    x2: 50.4837,
    y2: 51.9777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ACBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F73A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_605_4053",
    x1: 93.171,
    y1: 59.3703,
    x2: 87.6444,
    y2: 59.3703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ACBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F73A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_605_4053",
    x1: 35.6353,
    y1: 42.8377,
    x2: 55.5804,
    y2: 62.4031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF755C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_605_4053",
    x1: 50.302,
    y1: 25.7324,
    x2: 78.7876,
    y2: 53.6753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9356"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_605_4053",
    x1: 75.1812,
    y1: 52.7271,
    x2: 90.1891,
    y2: 67.4489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ACBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45A2E0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_605_4053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 105,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentationIcon);
export default __webpack_public_path__ + "static/media/PresentationIcon.7d93dec0f1a9160cc35f515dec0b7a36.svg";
export { ForwardRef as ReactComponent };